import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchSourcingModes = createAsyncThunk<
    { data: string[] },
    void,
    ThunkConfig<string>
>('fetchSourcingModes', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<{ data: string[] }>(
            `/v1/product_sourcing/settings/sourcing-modes`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
